import React, { useState } from 'react';
import { AlertTriangle, CheckCircle2, Calendar } from 'lucide-react';
interface QaRubricProps {
  leadName: string;
  setterName: string;
}
export function QaRubric({
  leadName,
  setterName
}: QaRubricProps) {
  const [scores, setScores] = useState({
    apertura: 3,
    necesidad: 2,
    objeciones: 3,
    cierre: 4,
    registro: 4
  });
  const [feedback, setFeedback] = useState('');
  const totalScore = Object.values(scores).reduce((a, b) => a + b, 0);
  const isRemediationRequired = totalScore < 14;
  const handleScoreChange = (item: keyof typeof scores, value: number) => {
    setScores(prev => ({
      ...prev,
      [item]: value
    }));
  };
  const rubricItems = [{
    id: 'apertura' as const,
    label: 'Apertura / Hook',
    desc: 'Claridad, tono, captar atención en 30s'
  }, {
    id: 'necesidad' as const,
    label: 'Identificación Necesidad',
    desc: 'Preguntas correctas, escucha activa'
  }, {
    id: 'objeciones' as const,
    label: 'Manejo Objeciones',
    desc: 'Respuestas a "no tengo tiempo", "ya tengo web"'
  }, {
    id: 'cierre' as const,
    label: 'Cierre Micro-acuerdo',
    desc: 'Llamado a la acción claro, confirmación'
  }, {
    id: 'registro' as const,
    label: 'Registro CRM',
    desc: 'Evidencia completa, campos correctos'
  }];
  return <div className="card overflow-hidden" data-id="element-528">
      <div className="p-5 border-b border-white/5 flex justify-between items-center bg-growthly-panel" data-id="element-529">
        <div data-id="element-530">
          <h3 className="text-[18px] font-semibold text-growthly-text" data-id="element-531">
            Evaluación QA
          </h3>
          <p className="text-[13px] text-growthly-muted mt-1" data-id="element-532">
            Lead:{' '}
            <span className="font-medium text-growthly-text" data-id="element-533">{leadName}</span> •
            Setter:{' '}
            <span className="font-medium text-growthly-text" data-id="element-534">{setterName}</span>
          </p>
        </div>
        <div className="text-right" data-id="element-535">
          <div className="text-[30px] font-bold text-growthly-text leading-none" data-id="element-536">
            {totalScore}
            <span className="text-[18px] text-growthly-muted font-normal" data-id="element-537">
              /20
            </span>
          </div>
          <div className={`text-[12px] font-medium mt-1 ${isRemediationRequired ? 'text-growthly-red' : 'text-growthly-green'}`} data-id="element-538">
            {isRemediationRequired ? 'Requiere Remediación' : 'Aprobado'}
          </div>
        </div>
      </div>

      {isRemediationRequired && <div className="bg-growthly-red/10 border-b border-growthly-red/30 p-4 flex items-start" data-id="element-539">
          <AlertTriangle className="w-5 h-5 text-growthly-red mr-3 flex-shrink-0 mt-0.5" data-id="element-540" />
          <div data-id="element-541">
            <h4 className="text-[14px] font-semibold text-growthly-red" data-id="element-542">
              Plan de remediación requerido
            </h4>
            <p className="text-[12px] text-growthly-red/80 mt-1" data-id="element-543">
              El score es menor a 14. Se requiere programar un feedback 1:1 y
              activar coaching por 7 días.
            </p>
          </div>
        </div>}

      <div className="p-5 space-y-6" data-id="element-544">
        <div className="space-y-4" data-id="element-545">
          {rubricItems.map(item => <div key={item.id} className="flex flex-col md:flex-row md:items-center justify-between gap-4 pb-4 border-b border-white/5 last:border-0 last:pb-0" data-id="element-546">
              <div className="flex-1" data-id="element-547">
                <h4 className="text-[14px] font-medium text-growthly-text" data-id="element-548">
                  {item.label}
                </h4>
                <p className="text-[12px] text-growthly-muted mt-1" data-id="element-549">
                  {item.desc}
                </p>
              </div>
              <div className="flex space-x-2" data-id="element-550">
                {[0, 1, 2, 3, 4].map(val => <button key={val} onClick={() => handleScoreChange(item.id, val)} className={`w-8 h-8 rounded flex items-center justify-center text-[13px] font-medium transition-colors ${scores[item.id] === val ? 'bg-growthly-green text-white' : 'bg-white/5 text-growthly-muted hover:bg-white/10 hover:text-growthly-text'}`} data-id="element-551">
                    {val}
                  </button>)}
              </div>
            </div>)}
        </div>

        <div data-id="element-552">
          <label className="block text-[13px] font-medium text-growthly-text mb-2" data-id="element-553">
            Acciones de mejora (1-3 items)
          </label>
          <textarea value={feedback} onChange={e => setFeedback(e.target.value)} rows={3} placeholder="Ej: 1. Mejorar el tono en la apertura. 2. No interrumpir al cliente..." className="input-field resize-none" data-id="element-554" />
        </div>

        <div className="flex justify-end space-x-3 pt-4 border-t border-white/5" data-id="element-555">
          <button className="btn-secondary inline-flex items-center" data-id="element-556">
            <Calendar className="w-4 h-4 mr-2" data-id="element-557" />
            Agendar 1:1 (≤72h)
          </button>
          <button className="btn-primary inline-flex items-center" data-id="element-558">
            <CheckCircle2 className="w-4 h-4 mr-2" data-id="element-559" />
            Guardar Evaluación
          </button>
        </div>
      </div>
    </div>;
}